module.exports = __webpack_public_path__ + "img/LiveQATopPictureOffer.47a824cb.png";